import styled from '@emotion/styled'
import { SPACING } from 'constants/spacing.constants'

export const Block = styled.div<{
    p?: keyof typeof SPACING
    mb?: keyof typeof SPACING
    fullWidth?: boolean
    fullHeight?: boolean
    maxWidthPct?: number
    widthPct?: number
    minWidthPct?: number
}>`
    ${({ p }) => p && `padding: ${SPACING[p]};`}
    ${({ mb }) => mb && `margin-bottom: ${SPACING[mb]};`}
    ${({ fullWidth }) => fullWidth && `width: 100%;`}
    ${({ fullHeight }) => fullHeight && `height: 100%;`}
    ${({ maxWidthPct }) => maxWidthPct && `max-width: ${maxWidthPct}%;`}
    ${({ widthPct }) => widthPct && `width: ${widthPct}%;`}
    ${({ minWidthPct }) => minWidthPct && `min-width: ${minWidthPct}%;`}
`
